<div class="certificate-search">

    <!-- ====================================================== -->
    <!-- HEADER -->
    <!-- ====================================================== -->

    <div class="search-header">

        <div class="search-header-info">

            <div class="search-header-icon">
                <i class="fa-solid fa-user"></i>
            </div>

            <div>

                <h6 class="search-title">
                    Búsqueda individual
                </h6>

                <p class="search-description">
                    Busca un certificado por nombre o correo electrónico,
                    o agrega rápidamente tus certificados.
                </p>

            </div>

        </div>


        <!-- MIS CERTIFICADOS -->

        <button
            type="button"
            class="my-certificates-btn"
            (click)="searchMyCertificates()"
            [disabled]="disabled">

            <i class="fa-solid fa-id-card"></i>

            <span>
                Mis certificados
            </span>

        </button>

    </div>


    <!-- ====================================================== -->
    <!-- BUSCADOR -->
    <!-- ====================================================== -->

    <div class="search-box">

        <div class="search-icon">
            <i class="fa-solid fa-magnifying-glass"></i>
        </div>

        <div class="search-autocomplete">

            <app-search-autocomplete
                [searchFunction]="search"
                [displayKey]="'nombre'"
                [secondaryDisplayKey]="'correo'"
                [placeholder]="'Buscar por correo'"
                [minLength]="3"
                [debounceTimeMs]="500"
                (itemSelected)="realizarBusqueda($event)">
            </app-search-autocomplete>

        </div>

    </div>


    <!-- ====================================================== -->
    <!-- RESULTADOS -->
    <!-- ====================================================== -->

    <div class="results-container">

        <div
            class="table-responsive"
            *ngIf="certificados.length > 0; else noCertificados">

            <table class="table certificates-table">

                <caption class="visually-hidden">
                    Certificados encontrados
                </caption>

                <thead>

                    <tr>

                        <th scope="col">
                            ID
                        </th>

                        <th scope="col">
                            Scratchcard
                        </th>

                        <th scope="col">
                            Nombre
                        </th>

                        <th scope="col">
                            Vigencia desde
                        </th>

                        <th scope="col">
                            Vigencia hasta
                        </th>

                        <th
                            scope="col"
                            class="action-column">

                            Acción

                        </th>

                    </tr>

                </thead>


                <tbody>

                    <tr *ngFor="let certificado of certificados">

                        <td>
                            {{ certificado.id }}
                        </td>

                        <td>
                            {{ certificado.scratchcard }}
                        </td>

                        <td>

                            <span
                                class="certificate-name"
                                [attr.title]="certificado.nombre">

                                {{ certificado.nombre }}

                            </span>

                        </td>

                        <td>

                            {{
                                certificado.fechaVigenciaDesde
                                    | date:'dd/MM/yyyy':'UTC'
                            }}

                        </td>

                        <td>

                            {{
                                certificado.fechaVigencia
                                    | date:'dd/MM/yyyy':'UTC'
                            }}

                        </td>

                        <td class="action-column">

                            <button
                                type="button"
                                class="add-certificate-btn"
                                (click)="agregarCertificadoLote(certificado)"
                                [disabled]="disabled"
                                title="Agregar certificado"
                                aria-label="Agregar certificado">

                                <i class="fa-solid fa-plus"></i>

                            </button>

                        </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</div>


<!-- ======================================================== -->
<!-- SIN RESULTADOS -->
<!-- ======================================================== -->

<ng-template #noCertificados>

    <div class="empty-results">

        <div class="empty-results-icon">

            <i class="fa-solid fa-magnifying-glass"></i>

        </div>

        <h6>
            Sin resultados
        </h6>

        <p>
            Busca un certificado para mostrar los resultados.
        </p>

    </div>

</ng-template>